module.exports = __webpack_public_path__ + "img/chrome-logo.4ca14ca5.svg";